


export class ProgressService {

  public getStatusForProgress(progress: number) {
    let status = '';
    if (progress > 75) {
      status = 'success-alt';
      if (progress === 100) {
        status = 'completed';
      }
    } else if (progress > 50) {
      status = 'success';
    } else if (progress > 25) {
      status = 'warning';
    } else {
      status = 'danger';
    }
    return status;
  }
}
